import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  setEditorTaskType,
  getEditorTaskType,
} from '@domains/orchestrator-pricing-committee/store/slices/domainOrchestratorPricingCommittee.slice';

const taskTypes = ['aprobologia_reintentado', 'aprobologia', 'pricing_comite'] as const;

export const EditorTaskTypeSelect = () => {
  const dispatch = useDispatch();
  const taskType = useSelector(getEditorTaskType);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    dispatch(setEditorTaskType(e.target.value));
  };

  return (
    <Form.Select
      data-testid="editor-task-type-select"
      style={{ width: '200px' }}
      value={taskType}
      onChange={handleChange}
    >
      <option value="">Seleccione tipo</option>
      {taskTypes.map(type => (
        <option key={type} value={type}>
          {type}
        </option>
      ))}
    </Form.Select>
  );
};
